import React from 'react';
import { BoundSelect } from "../BoundSelect";
import { YesNo } from "../../../../constants/securspace-constants";

type BoundYesNoSelectProps<T> = {
  label?: string;
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundYesNoSelect = <T,>({
  label = "Yes or No",
  name,
  value = '',
  onChange
}: BoundYesNoSelectProps<T>) => {

  return <BoundSelect<T>
    options={YesNo}
    label={label}
    name={name}
    value={value}
    onChange={onChange}
  />
}

export { BoundYesNoSelect };